const foreignLaborView = (data) => {
  let formData =
    data && data.getRecruiterById && data.getRecruiterById.RecruiterFormData;
  if (formData) {
    let view = {
      name: formData.new_profile_fl_recr_profile_name,
      sections: [
        {
          name: "Recruiter - Name",
          fields: [
            {
              number: 1,
              label: "Last Name",
              value: formData.new_profile_fl_recr_last_name,
            },
            {
              number: 2,
              label: "First Name",
              value: formData.new_profile_fl_recr_first_name,
            },
            {
              number: 3,
              label: "Middle Name",
              value: formData.new_profile_fl_recr_middle_name,
            },
            {
              number: 4,
              label: "Employer Name",
              value: formData.new_profile_fl_recr_employer_name,
            },
          ],
        },
        {
          name: "Location",
          fields: [
            {
              number: 5,
              label: "City",
              value: formData.new_profile_fl_recr_city,
            },
            {
              number: 6,
              label: "State",
              value: formData.new_profile_fl_recr_state_id,
            },
            {
              number: 7,
              label: "Postal Code",
              value: formData.new_profile_fl_recr_zip,
            },
            {
              number: 8,
              label: "Country",
              value: formData.new_profile_fl_recr_country_id,
            },
            {
              number: 9,
              label: "Province",
              value: formData.new_profile_fl_recr_province,
            },
          ],
        },
        {
          name: "For H-2A Applications Only",
          fields: [
            {
              number: 10,
              label: "Registration Number 1",
              value: formData.new_profile_fl_recr_reg_num_1,
            },
            {
              number: 11,
              label: "Registration Number Country 1",
              value: formData.new_profile_fl_recr_reg_num_country_1,
            },
            {
              number: 12,
              label: "Registration Number 2",
              value: formData.new_profile_fl_recr_reg_num_2,
            },
            {
              number: 13,
              label: "Registration Number Country 2",
              value: formData.new_profile_fl_recr_reg_num_country_2,
            },
            {
              number: 14,
              label: "Registration Number 3",
              value: formData.new_profile_fl_recr_reg_num_3,
            },
            {
              number: 15,
              label: "Registration Number Country 3",
              value: formData.new_profile_fl_recr_reg_num_country_3,
            },
          ],
        },
      ],
    };
    return view;
  }
};

export default foreignLaborView;
